import api from '@/plugins/api'

export default {
  state: () => ({
    items: []
  }),
  mutations: {
    SET_DATA_SALES(state, data) {
      Object.entries(data).forEach(entry => {
        state[entry[0]] = entry[1]
      })
    }
  },
  actions: {
    async getSales({ commit }) {
      try {
        const url = new URL(`${process.env.VUE_APP_DIRECTUS_URL}items/sales`)
        url.searchParams.append('fields', ['*', 'translations.*'])
        url.searchParams.append(
          'filter',
          JSON.stringify({
            is_active: { _eq: true },
            is_draft: { _null: true },
            is_hidden: { _neq: true }
          })
        )

        const response = await api.get(url.toString())

        if (response?.code !== 200) return

        commit('SET_DATA_SALES', { items: response.data.data || [] })
      } catch (error) {
        console.error('Failed to get sales:', error)
      }
    }
  },
  getters: {}
}
